var chunkMapping = {
	"386": [
		40386
	],
	"714": [
		714
	],
	"866": [
		90866
	],
	"1049": [
		21049
	],
	"1240": [
		1240
	],
	"1451": [
		61451
	],
	"1499": [
		1499
	],
	"1585": [
		11585
	],
	"2369": [
		2369
	],
	"2516": [
		72516
	],
	"3130": [
		33130
	],
	"3923": [
		3923
	],
	"4004": [
		14004
	],
	"4613": [
		34613
	],
	"5265": [
		65265
	],
	"5305": [
		95305
	],
	"6888": [
		6888
	],
	"7789": [
		27789
	],
	"7904": [
		37904
	],
	"7921": [
		77921
	],
	"8147": [
		58147
	],
	"8383": [
		98383
	],
	"8969": [
		78969
	],
	"9088": [
		99088
	]
};
var idToExternalAndNameMapping = {
	"714": [
		"default",
		"./insights-common/cn.json",
		72918
	],
	"1240": [
		"default",
		"./insights-new/en.json",
		72918
	],
	"1499": [
		"default",
		"./common-patent/en.json",
		72918
	],
	"2369": [
		"default",
		"./insights-new/jp.json",
		72918
	],
	"3923": [
		"default",
		"./common-country/jp.json",
		72918
	],
	"6888": [
		"default",
		"./common-errorcode/jp.json",
		72918
	],
	"11585": [
		"default",
		"./analytics-group-assignees/cn.json",
		72918
	],
	"14004": [
		"default",
		"./common-country/cn.json",
		72918
	],
	"21049": [
		"default",
		"./common-product/cn.json",
		72918
	],
	"27789": [
		"default",
		"./analytics-snap-business/cn.json",
		72918
	],
	"33130": [
		"default",
		"./insights-common/jp.json",
		72918
	],
	"34613": [
		"default",
		"./insights-new/cn.json",
		72918
	],
	"37904": [
		"default",
		"./analytics-group-assignees/en.json",
		72918
	],
	"40386": [
		"default",
		"./common-patent/jp.json",
		72918
	],
	"58147": [
		"default",
		"./analytics-group-assignees/jp.json",
		72918
	],
	"61451": [
		"default",
		"./analytics-snap-business/en.json",
		72918
	],
	"65265": [
		"default",
		"./common-patent/cn.json",
		72918
	],
	"72516": [
		"default",
		"./insights-common/en.json",
		72918
	],
	"77921": [
		"default",
		"./common-errorcode/en.json",
		72918
	],
	"78969": [
		"default",
		"./common-country/en.json",
		72918
	],
	"90866": [
		"default",
		"./common-product/jp.json",
		72918
	],
	"95305": [
		"default",
		"./analytics-snap-business/jp.json",
		72918
	],
	"98383": [
		"default",
		"./common-errorcode/cn.json",
		72918
	],
	"99088": [
		"default",
		"./common-product/en.json",
		72918
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}